import { useEffect } from 'react';
import { notifyError } from '../utils/notify';

const ALLOW =
  /목록|검색|닫기|취소|상세|PDF|다운로드|열람|열기|조회|보기|새로고침|적용|이전|다음|접기|펼치|탭|필터|정렬|복사|미리보기|확대|축소|확인/i;
const BLOCK =
  /등록|삭제|승인|결재|수정|저장|추가|업로드|제거|생성|확정|채택|초대|작성|제출|이관|비활성|배치|권한/i;

/**
 * 게스트 모드에서 쓰기성 클릭·폼 제출을 UI에서 차단 (BE GuestWriteGuardFilter 보조).
 */
export function useGuestReadOnlyGuard(enabled: boolean) {
  useEffect(() => {
    if (!enabled) return;
    const root = document.querySelector('.ec-app');
    if (!root) return;

    const shouldBlockButton = (btn: HTMLElement) => {
      if (btn.closest('[data-guest-allow], [data-guest-admin-ui]')) return false;
      const label = (btn.textContent || '').replace(/\s+/g, '');
      if (!label) return false;
      if (ALLOW.test(label) && !BLOCK.test(label)) return false;
      return BLOCK.test(label);
    };

    const onClick = (event: Event) => {
      const target = event.target as HTMLElement | null;
      if (!target) return;
      if (target.closest('[data-guest-admin-ui]')) return;
      const btn = target.closest('button, [role="menuitem"]') as HTMLElement | null;
      if (!btn || !root.contains(btn)) return;
      if (!shouldBlockButton(btn)) return;
      event.preventDefault();
      event.stopPropagation();
      notifyError('게스트 계정은 조회만 가능합니다.');
    };

    const onSubmit = (event: Event) => {
      const form = event.target as HTMLFormElement | null;
      if (!form || !root.contains(form)) return;
      if (form.closest('[data-guest-allow], [data-guest-admin-ui]')) return;
      event.preventDefault();
      event.stopPropagation();
      notifyError('게스트 계정은 조회만 가능합니다.');
    };

    const onChange = (event: Event) => {
      const input = event.target as HTMLInputElement | null;
      if (!input || input.type !== 'file' || !root.contains(input)) return;
      if (input.closest('[data-guest-allow], [data-guest-admin-ui]')) return;
      input.value = '';
      event.preventDefault();
      event.stopPropagation();
      notifyError('게스트 계정은 조회만 가능합니다.');
    };

    root.addEventListener('click', onClick, true);
    root.addEventListener('submit', onSubmit, true);
    root.addEventListener('change', onChange, true);
    return () => {
      root.removeEventListener('click', onClick, true);
      root.removeEventListener('submit', onSubmit, true);
      root.removeEventListener('change', onChange, true);
    };
  }, [enabled]);
}
